"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationParameter = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
let NotificationParameter = class NotificationParameter {
};
exports.NotificationParameter = NotificationParameter;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)({ name: "id", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], NotificationParameter.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ unique: true }),
    tslib_1.__metadata("design:type", String)
], NotificationParameter.prototype, "key", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ nullable: true }),
    tslib_1.__metadata("design:type", String)
], NotificationParameter.prototype, "description", void 0);
exports.NotificationParameter = NotificationParameter = tslib_1.__decorate([
    (0, typeorm_1.Entity)('notification_parameter')
], NotificationParameter);
